
import { Footerdemo } from "@/components/ui/footer-section";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-studio-cream">
      <div className="container mx-auto px-4 py-16 max-w-4xl">
        <h1 className="text-4xl font-bold mb-8 text-studio-stone">Privacy Policy</h1>
        <div className="prose max-w-none text-studio-stone/80">
          <p className="mb-4">Last updated: {new Date().toLocaleDateString()}</p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4 text-studio-stone">1. Introduction</h2>
          <p className="mb-4">WireFuseMedia, LLC ("we," "our," or "us") respects your privacy and is committed to protecting it through our compliance with this policy.</p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4 text-studio-stone">2. Information We Collect</h2>
          <p className="mb-4">We collect information that you provide directly to us when making a booking or contacting us, including:</p>
          <ul className="list-disc ml-6 mb-4">
            <li>Name and contact information</li>
            <li>Booking details and preferences</li>
            <li>Payment information</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8 mb-4 text-studio-stone">3. How We Use Your Information</h2>
          <p className="mb-4">We use the information we collect to:</p>
          <ul className="list-disc ml-6 mb-4">
            <li>Process your bookings</li>
            <li>Communicate with you about our services</li>
            <li>Improve our services</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8 mb-4 text-studio-stone">4. Contact Us</h2>
          <p className="mb-4">For any questions about this Privacy Policy, please contact us at: interview@mindhack.com</p>
        </div>
      </div>
      <Footerdemo />
    </div>
  );
};

export default PrivacyPolicy;
